import * as types from '../mutation-types';

// state
export const state = {
  enterprise: null,
};

// getters
export const getters = {
  enterprise: (state) => state.enterprise,
};

// mutations
export const mutations = {
  [types.SET_CURRENT_ENTERPRISE](state, { enterprise }) {
    state.enterprise = enterprise;
  },
  [types.RESET_ENTERPRISE](state) {
    state.enterprise = null;
  },
};

// actions
export const actions = {
  setCurrentEnterprise({ commit }, { enterprise }) {
    commit(types.SET_CURRENT_ENTERPRISE, { enterprise });
  },
  resetEnterprise({ commit }) {
    commit(types.RESET_ENTERPRISE);
  },
};
